import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { VisitType } from "@app/models/rest/visit-type";

@Injectable({
  providedIn: "root"
})
export class VisitTypeRestService extends HateoasResourceOperation<VisitType> {
  constructor() {
    super(VisitType);
  }
}
